module.exports = __webpack_public_path__ + "img/four4Red.fc812d0b.jpg";